export const EEntityCheckStatus = {
  "0": "UNKNOWN",
  "1": "NEW",
  "2": "PROCESSING",
  "3": "COMPLETED",
  "4": "CANCELLED",
  "-1": "ALL"
};

export const EEntityCheckType = {
  "0": "UNKNOWN",
  "1": "ENTITY_MIGHT_NOT_EXISTS",
  "2": "SUB_ENTITY_NOT_EXISTS",
  "3": "INVALID_ENTITY_IDENTIFIER",
  "4": "INVALID_ENTITY_STATUS",
  "5": "PENDING_STATUS_NOT_SUCCEEDED",
  "6": "PENDING_STATUS_DURATION_EXPIRED",
  "7": "PNR_QUEUE_SCAN_UNKNOWN_ENTITY",
  "8": "ENTITY_DEFAULT_CROSSCHECK",
  "9": "INVALID_ENTITY_PRICE",
  "10": "INVALID_ENTITY_CONTENT",
  "11": "ENTITY_MANUAL_CROSSCHECK",
  "-1": "ALL"
};